import React from 'react';
import { Grid } from '@mui/material';
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';
import W86PlaceholderTextField from '../../W86Components/W86PlaceholderTextField';

const SampleParseSection = ({
  skipSample,
  onSkipSampleChange,
  rawResponsePlaceholderName,
  onRawResponsePlaceholderChange,
  onFocus,
  validateRequest,
  isNavigating,
}) => {
  return (
    <>
      {!skipSample && (
        <>
          <Grid item xs={12}>
            <div className="sample-parse-label">Sample and parse JSON</div>
          </Grid>
          <Grid item xs={12}>
            <Switch
              checked={!skipSample}
              onChange={value => onSkipSampleChange(!value.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12} hidden={!skipSample}>
        <div className="raw-response-info">
          The raw JSON response will be outputted as this placeholder
        </div>
      </Grid>
      <Grid item xs={12} className="width-100" hidden={!skipSample}>
        <W86PlaceholderTextField
          value={rawResponsePlaceholderName}
          placeholderText="Insert placeholder"
          handleChange={e => onRawResponsePlaceholderChange(e.target.value)}
          onFocus={() => onFocus('rawResponsePlaceholderName')}
        />
      </Grid>

      <Grid item xs={12} className="dialogContentRight apiNextButton" hidden={skipSample}>
        <Grid item xs={12}>
          <Button
            onClick={() => validateRequest(isNavigating)}
            variant={'contained'}
            color={'primary'}
          >
            {' '}
            Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SampleParseSection;
